import { render, staticRenderFns } from "./CardTokenModal.vue?vue&type=template&id=b22e517e&scoped=true"
import script from "./CardTokenModal.vue?vue&type=script&lang=js"
export * from "./CardTokenModal.vue?vue&type=script&lang=js"
import style0 from "./CardTokenModal.vue?vue&type=style&index=0&id=b22e517e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22e517e",
  null
  
)

export default component.exports